module.exports = __webpack_public_path__ + "img/ecosystem.0b34a6d4.png";